import React, { useState } from 'react';

const PopularPicks = () => {
  const [favorites, setFavorites] = useState({});

  const products = [
    {
      id: 1,
      name: "Wooden Queen Size Bed",
      originalPrice: 475,
      discountedPrice: 361,
      discount: 24,
      image: "🛏️",
      condition: "Mint Condition"
    },
    {
      id: 2,
      name: "Double Door Wardrobe (Wooden)",
      originalPrice: 379,
      discountedPrice: 273,
      discount: 28,
      image: "🚪",
      condition: "Mint Condition"
    },
    {
      id: 3,
      name: "Wooden Study Table (3 Drawer)",
      originalPrice: 235,
      discountedPrice: 186,
      discount: 21,
      image: "📚",
      condition: "Mint Condition"
    },
    {
      id: 4,
      name: "Book Shelf",
      originalPrice: 187,
      discountedPrice: 163,
      discount: 13,
      image: "📖",
      condition: "Mint Condition"
    }
  ];

  const toggleFavorite = (productId) => {
    setFavorites(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  return (
    <section className="py-8 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 lg:mb-16">
          <div className="mb-4 sm:mb-0">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-800 mb-2">
              Popular Picks
            </h2>
            <p className="text-base lg:text-lg text-gray-600">
              Our most loved furniture pieces!
            </p>
          </div>
          
          {/* Action Buttons */}
          <div className="flex space-x-4">
            <button className="bg-gradient-to-r from-gray-900 to-gray-800 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:from-gray-800 hover:to-gray-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105">
              Rent
            </button>
            <button className="border-2 border-gray-800 text-gray-800 px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-800 hover:text-white transition-all duration-200">
              Buy
            </button>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-xl lg:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
            >
              {/* Product Image */}
              <div className="relative h-40 sm:h-48 lg:h-56 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                <div className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl">{product.image}</div>
                
                {/* Condition Badge */}
                <div className="absolute top-2 sm:top-3 left-2 sm:left-3">
                  <span className="bg-purple-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                    {product.condition}
                  </span>
                </div>
                
                {/* Favorite Button */}
                <button
                  onClick={() => toggleFavorite(product.id)}
                  className="absolute top-2 sm:top-3 right-2 sm:right-3 w-7 h-7 sm:w-8 sm:h-8 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full flex items-center justify-center transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  <svg 
                    className={`w-4 h-4 sm:w-5 sm:h-5 transition-all duration-200 ${
                      favorites[product.id] 
                        ? 'text-red-500 fill-current' 
                        : 'text-gray-600'
                    }`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </button>
              </div>

              {/* Product Info */}
              <div className="p-3 sm:p-4 lg:p-6">
                {/* Product Name */}
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-2 group-hover:text-gray-900 transition-colors duration-200">
                  {product.name}
                </h3>
                
                {/* Discount Badge */}
                <div className="mb-2 sm:mb-3">
                  <span className="bg-purple-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                    {product.discount}% OFF
                  </span>
                </div>
                
                {/* Pricing */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-500 text-xs sm:text-sm line-through">
                      ₹{product.originalPrice}/mo
                    </span>
                    <span className="text-lg sm:text-xl font-bold text-gray-800">
                      ₹{product.discountedPrice}/mo
                    </span>
                  </div>
                  
                  {/* Navigation Button */}
                  <button className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-900 text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-200 transform hover:scale-110">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-8 lg:mt-16">
          <button className="border-2 border-gray-800 text-gray-800 px-6 sm:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl text-base sm:text-lg font-semibold hover:bg-gray-800 hover:text-white transition-all duration-200 transform hover:scale-105">
            View All →
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularPicks; 